import React from "react";

function UpArrowLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99989 9.20831L5.87489 13.3333L4.69656 12.155L9.99989 6.85165L15.3032 12.155L14.1249 13.3333L9.99989 9.20831Z"
        fill="#0E0E0E"
      />
    </svg>
  );
}

export default UpArrowLogo;
